import gql from 'graphql-tag';

export const subSurfaceNodeCopiedSubscription = gql`
  subscription subSurfaceCopied($surface: ID!) {
    subSurfaceCopied(surface: $surface) {
      ... on SubSurfaceNode {
        name
      }
    }
  }
`;
